import Tab from "bootstrap/js/dist/tab";

document.addEventListener("turbo:load", function () {
  if (!document.querySelector(".js-tabs")) return;

  var triggerTabList = [].slice.call(document.querySelectorAll(".js-tabs a"));
  triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new Tab(triggerEl);

    triggerEl.addEventListener("click", function (e) {
      e.preventDefault();
      tabTrigger.show();
    });
  });

  /* document.querySelectorAll('a[data-bs-toggle="tab"]').forEach(tabLink => {
    tabLink.addEventListener('shown.bs.tab', function (e) {
      history.pushState({}, '', e.target.hash);
    });
  }); */

  var hash = document.location.hash;
  var prefix = "tab_";
  if (hash) {
    let triggerEl = document.querySelector(
      '.js-tabs a[href="' + hash.replace(prefix, "") + '"]'
    );
    if (!triggerEl) return;
    Tab.getInstance(triggerEl).show();
    triggerEl.scrollIntoView();
  }
});
